import React from "react";
import logo from "../logo.png";

const Loader = () => {
  return (
    <>
      <style>{`
        @keyframes acc-logo-blink {
          0%   { opacity: 1;   }
          50%  { opacity: 0.1; }
          100% { opacity: 1;   }
        }
        @keyframes acc-dots {
          0%   { opacity: 0.2; }
          50%  { opacity: 1;   }
          100% { opacity: 0.2; }
        }
        .acc-loader-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 60vh;
          gap: 20px;
        }
        .acc-loader-logo {
          width: 90px;
          animation: acc-logo-blink 1.2s ease-in-out infinite;
        }
        .acc-loader-text {
          font-size: 0.88rem;
          font-weight: 600;
          color: #6c757d;
          letter-spacing: 0.04em;
          display: flex;
          gap: 2px;
        }
        .acc-loader-text span {
          display: inline-block;
          animation: acc-dots 1.4s ease-in-out infinite;
        }
        .acc-loader-text span:nth-child(2) { animation-delay: 0.2s; }
        .acc-loader-text span:nth-child(3) { animation-delay: 0.4s; }
      `}</style>

      <div className="acc-loader-wrap">
        <img
          src={logo}
          alt="Loading..."
          className="acc-loader-logo"
        />
        <div className="acc-loader-text">
          Communicating with database
          <span>.</span><span>.</span><span>.</span>
        </div>
      </div>
    </>
  );
};

export default Loader;
